import React from "react";
import ReactGA from "react-ga";
import {HeaderMenuComponent} from "./HeaderMenuComponent";
import {BannerComponent} from "./BannerComponent";
import {AboutComponent} from "./AboutComponent";
import {GalleryComponent} from "./GalleryComponent";
//import {ServicesComponent} from "./ServicesComponent";
import {ContactComponent} from "./ContactComponent";
import {FooterComponent} from "./../Common/FooterComponent";

//import logo from "./../images/logo.svg";
import "./../../css/landing-page.css";

export class LandingPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bannersLoaded: false
        };

        this.handlePostBannerLoad = this.handlePostBannerLoad.bind(this);
    }

    componentDidMount() {
        let top = 0;
        if (this.props.match.params.name) {
            let paramName = this.props.match.params.name.toLowerCase();
            let component = document.getElementById(paramName + "-component");

            switch (paramName) {
              case "about":
                  top = component.getBoundingClientRect().top;
                  window.history.replaceState({}, "Wilson Ng Photography", "/about");
                  // Tracking
                  ReactGA.pageview(window.location.pathname.toLowerCase());
                  break;

              case "gallery":
                  top = component.getBoundingClientRect().top;
                  window.history.replaceState({}, "Wilson Ng Photography", "/gallery");
                  // Tracking
                  ReactGA.pageview(window.location.pathname.toLowerCase());
                  break;

              case "contact":
                  top = component.getBoundingClientRect().top;
                  window.history.replaceState({}, "Wilson Ng Photography", "/contact");
                  // Tracking
                  ReactGA.pageview(window.location.pathname.toLowerCase());
                  break;

              default:
                  window.history.replaceState({}, "Wilson Ng Photography", "/");
                  // Tracking
                  ReactGA.pageview("/");
            }
        } else {
            // Tracking
            ReactGA.pageview(window.location.pathname.toLowerCase());
        }

        window.scrollTo(0, top);

        // const rect = this.refs.galleryComponent.getBoundingClientRect();
        // let a = document.getElementById(this.state.a);
        // let h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        //
        // console.info("A TOP:" + a.getBoundingClientRect().top);
        // console.info("A height:" + a.getBoundingClientRect().bottom);
        // console.info("Viewport Height:" + h);
    }

    handlePostBannerLoad() {
        this.setState({
            bannersLoaded: true
        });

        // const sources = [
        //     require("./../../images/loading.svg"),
        //     require("./../../images/Landscape/liquid-floral.jpg"),
        //     require("./../../images/Landscape/autumn-maroon-bells.jpg")
        // ];
        //
        // for (let i=0; i < sources.length; i++) {
        //     let image = new Image();
        //     image.src = sources[i];
        // }
    }

    render() {
        let preloadImages = "";
        if (this.state.bannersLoaded) {
            const sources = [
                require("./../../images/loading.svg"),
                require("./../../images/Landscape/drought.jpg"),
                require("./../../images/Landscape/dancing-aspen.jpg"),
                require("./../../images/Landscape/cosmic-canopy.jpg"),
                require("./../../images/Landscape/superbowl-50.jpg"),
                require("./../../images/Landscape/liquid-floral.jpg"),
                require("./../../images/Landscape/superbowl-fireworks.jpg"),
                require("./../../images/Landscape/under-maple-canopy.jpg"),
                require("./../../images/Landscape/sand-towers.jpg"),
                require("./../../images/Landscape/allure.jpg"),
                require("./../../images/Landscape/maroon-bells-autumn.jpg"),
//                require("./../../images/Landscape/lone-tree.jpg")
//                require("./../../images/Landscape/el-capitan.jpg")
            ];
            preloadImages = <div className="hidden">
                                {sources.map((src, index) => {return <img src={src} key={index} alt="" />;})}
                            </div>;
        }

        return (
            <div id="landing-page">
                <HeaderMenuComponent />
                <BannerComponent postLoad={this.handlePostBannerLoad} />
                <AboutComponent />
                <GalleryComponent />
                <ContactComponent />
                <FooterComponent />
                {preloadImages}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Scroll/LandingPage.js